// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "javascript/chunks/" + "c00e16ed21f6e3bc1222" + ".min.js";
};